import React, { useState } from "react";
import "../../../assets/css/admin/UsersManagement.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const UsersManagement = () => {
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewMode, setViewMode] = useState("table");

  const [users, setUsers] = useState([
    {
      id: 1,
      name: "Ahmed Khan",
      email: "ahmed.khan@email.com",
      role: "Student",
      status: "Active",
      joinedDate: "2024-01-15",
      coursesEnrolled: 5,
      coursesCompleted: 2,
      avatar: "AK",
      phone: "+92 300 1234567",
      location: "Karachi, Pakistan",
    },
    {
      id: 2,
      name: "Sara Ali",
      email: "sara.ali@email.com",
      role: "Mentor",
      status: "Active",
      eligibility: "Eligible",
      joinedDate: "2023-11-20",
      coursesEnrolled: 0,
      coursesCompleted: 0,
      studentsTeaching: 45,
      rating: 4.8,
      avatar: "SA",
      phone: "+92 321 9876543",
      location: "Lahore, Pakistan",
    },
    {
      id: 3,
      name: "Hassan Raza",
      email: "hassan.raza@email.com",
      role: "Student",
      status: "Inactive",
      joinedDate: "2024-03-10",
      coursesEnrolled: 3,
      coursesCompleted: 1,
      avatar: "HR",
      phone: "+92 333 5551234",
      location: "Islamabad, Pakistan",
    },
    {
      id: 4,
      name: "Fatima Malik",
      email: "fatima.malik@email.com",
      role: "Student",
      status: "Active",
      joinedDate: "2024-04-05",
      coursesEnrolled: 8,
      coursesCompleted: 5,
      avatar: "FM",
      phone: "+92 345 7778888",
      location: "Multan, Pakistan",
    },
    {
      id: 5,
      name: "Usman Sheikh",
      email: "usman.sheikh@email.com",
      role: "Mentor",
      status: "Pending",
      eligibility: "Pending",
      joinedDate: "2023-09-12",
      coursesEnrolled: 0,
      coursesCompleted: 0,
      studentsTeaching: 38,
      rating: 4.7,
      avatar: "US",
      phone: "+92 312 4445555",
      location: "Faisalabad, Pakistan",
    },
    {
      id: 6,
      name: "Zainab Yusuf",
      email: "zainab.yusuf@email.com",
      role: "Admin",
      status: "Active",
      joinedDate: "2023-06-01",
      coursesEnrolled: 0,
      coursesCompleted: 0,
      avatar: "ZY",
      phone: "+92 300 9998888",
      location: "Karachi, Pakistan",
    },
    {
      id: 7,
      name: "Ali Hassan",
      email: "ali.hassan@email.com",
      role: "Mentor",
      status: "Rejected",
      eligibility: "Rejected",
      joinedDate: "2024-02-10",
      coursesEnrolled: 0,
      coursesCompleted: 0,
      studentsTeaching: 0,
      rating: 0,
      avatar: "AH",
      phone: "+92 301 1112222",
      location: "Peshawar, Pakistan",
    },
  ]);

  const stats = {
    total: users.length,
    students: users.filter((u) => u.role === "Student").length,
    mentors: users.filter((u) => u.role === "Mentor").length,
    active: users.filter((u) => u.status === "Active").length,
    inactive: users.filter((u) => u.status === "Inactive").length,
  };

  const filteredUsers = users.filter((user) => {
    const matchesFilter =
      selectedFilter === "all" ||
      user.role.toLowerCase() === selectedFilter ||
      user.status.toLowerCase() === selectedFilter;
    const matchesSearch =
      user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const handleUserClick = (user) => {
    setSelectedUser(user);
  };

  const closeModal = () => {
    setSelectedUser(null);
  };

  const handleApprove = (e, userId) => {
    e.stopPropagation();
    setUsers(
      users.map((u) =>
        u.id === userId
          ? { ...u, eligibility: "Eligible", status: "Active" }
          : u,
      ),
    );
  };

  const handleReject = (e, userId) => {
    e.stopPropagation();
    setUsers(
      users.map((u) =>
        u.id === userId
          ? { ...u, eligibility: "Rejected", status: "Rejected" }
          : u,
      ),
    );
  };

  const handleToggleStatus = (e, userId) => {
    e.stopPropagation();
    setUsers(
      users.map((u) =>
        u.id === userId
          ? { ...u, status: u.status === "Active" ? "Inactive" : "Active" }
          : u,
      ),
    );
  };

  const exportToCSV = () => {
    const headers = [
      "Name",
      "Email",
      "Role",
      "Status",
      "Courses/Students",
      "Eligibility",
      "Joined Date",
    ];

    const csvData = filteredUsers.map((user) => {
      const coursesOrStudents =
        user.role === "Student"
          ? `${user.coursesCompleted}/${user.coursesEnrolled}`
          : user.role === "Mentor"
            ? `${user.studentsTeaching} students`
            : "—";

      const eligibility =
        user.role === "Mentor" ? user.eligibility || "—" : "—";

      return [
        user.name,
        user.email,
        user.role,
        user.status,
        coursesOrStudents,
        eligibility,
        user.joinedDate,
      ];
    });

    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `users_export_${new Date().getTime()}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getRoleBadgeColor = (role) => {
    const colors = {
      student: { bg: "#e3f2fd", color: "#1976d2" },
      mentor: { bg: "#f3e5f5", color: "#7b1fa2" },
      admin: { bg: "#fff3e0", color: "#f57c00" },
    };
    return colors[role.toLowerCase()] || colors.student;
  };

  const getEligibilityBadgeColor = (eligibility) => {
    const colors = {
      eligible: { bg: "#e8f5e9", color: "#388e3c" },
      pending: { bg: "#fff3e0", color: "#f57c00" },
      rejected: { bg: "#ffebee", color: "#d32f2f" },
    };
    return colors[eligibility?.toLowerCase()] || colors.pending;
  };

  return (
    <AdminLayout>
      <div className="user-management-container">
        <div className="user-header">
          <div>
            <p className="user-subtitle">
              Manage students, mentors, and administrators
            </p>
          </div>
        </div>

        <div className="user-stats-grid">
          <div className="user-stat-card">
            <div className="user-stat-icon user-stat-total">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <div className="user-stat-content">
              <span className="user-stat-value">{stats.total}</span>
              <span className="user-stat-label">Total Users</span>
            </div>
          </div>

          <div className="user-stat-card">
            <div className="user-stat-icon user-stat-students">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div className="user-stat-content">
              <span className="user-stat-value">{stats.students}</span>
              <span className="user-stat-label">Students</span>
            </div>
          </div>

          <div className="user-stat-card">
            <div className="user-stat-icon user-stat-mentors">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <line x1="23" y1="11" x2="17" y2="11"></line>
                <line x1="20" y1="8" x2="20" y2="14"></line>
              </svg>
            </div>
            <div className="user-stat-content">
              <span className="user-stat-value">{stats.mentors}</span>
              <span className="user-stat-label">Mentors</span>
            </div>
          </div>

          <div className="user-stat-card">
            <div className="user-stat-icon user-stat-active">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <div className="user-stat-content">
              <span className="user-stat-value">{stats.active}</span>
              <span className="user-stat-label">Active Users</span>
            </div>
          </div>
        </div>

        <div className="user-controls">
          <div className="user-filter-section">
            <div className="user-filter-tabs">
              <button
                className={`user-filter-tab ${selectedFilter === "all" ? "user-active" : ""}`}
                onClick={() => setSelectedFilter("all")}
              >
                All Users
              </button>
              <button
                className={`user-filter-tab ${selectedFilter === "student" ? "user-active" : ""}`}
                onClick={() => setSelectedFilter("student")}
              >
                Students
              </button>
              <button
                className={`user-filter-tab ${selectedFilter === "mentor" ? "user-active" : ""}`}
                onClick={() => setSelectedFilter("mentor")}
              >
                Mentors
              </button>
              <button
                className={`user-filter-tab ${selectedFilter === "active" ? "user-active" : ""}`}
                onClick={() => setSelectedFilter("active")}
              >
                Active
              </button>
              <button
                className={`user-filter-tab ${selectedFilter === "inactive" ? "user-active" : ""}`}
                onClick={() => setSelectedFilter("inactive")}
              >
                Inactive
              </button>
            </div>
          </div>

          <div className="user-control-actions">
            <div className="user-search-box">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              <input
                type="text"
                placeholder="Search users..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="user-view-toggle">
              <button
                className={`user-view-btn ${viewMode === "table" ? "user-active" : ""}`}
                onClick={() => setViewMode("table")}
                title="Table View"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </button>
              <button
                className={`user-view-btn ${viewMode === "grid" ? "user-active" : ""}`}
                onClick={() => setViewMode("grid")}
                title="Grid View"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {viewMode === "table" && (
          <div className="user-table-wrapper">
            <table className="user-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Courses</th>
                  <th>Eligibility</th>
                  <th>Joined</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user.id} onClick={() => handleUserClick(user)}>
                    <td>
                      <div className="user-cell">
                        <div className="user-avatar">{user.avatar}</div>
                        <div className="user-info">
                          <span className="user-name">{user.name}</span>
                          <span className="user-email">{user.email}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        className="user-role-badge"
                        style={{
                          backgroundColor: getRoleBadgeColor(user.role).bg,
                          color: getRoleBadgeColor(user.role).color,
                        }}
                      >
                        {user.role}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`user-status-badge user-status-${user.status.toLowerCase()}`}
                      >
                        {user.status}
                      </span>
                    </td>
                    <td>
                      {user.role === "Student" ? (
                        <span className="user-course-count">
                          {user.coursesCompleted}/{user.coursesEnrolled}
                        </span>
                      ) : user.role === "Mentor" ? (
                        <span className="user-student-count">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                          </svg>
                          {user.studentsTeaching} students
                        </span>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>
                      {user.role === "Mentor" ? (
                        user.eligibility === "Pending" ? (
                          <div className="user-eligibility-actions">
                            <button
                              className="user-approve-btn"
                              onClick={(e) => handleApprove(e, user.id)}
                              title="Approve"
                            >
                              Approve
                            </button>
                            <button
                              className="user-reject-btn"
                              onClick={(e) => handleReject(e, user.id)}
                              title="Reject"
                            >
                              Reject
                            </button>
                          </div>
                        ) : (
                          <span
                            className="user-eligibility-badge"
                            style={{
                              backgroundColor: getEligibilityBadgeColor(
                                user.eligibility,
                              ).bg,
                              color: getEligibilityBadgeColor(user.eligibility)
                                .color,
                            }}
                          >
                            {user.eligibility}
                          </span>
                        )
                      ) : (
                        "—"
                      )}
                    </td>
                    <td className="user-joined-date">{user.joinedDate}</td>
                    <td>
                      <div className="user-action-buttons">
                        <button
                          className="user-action-btn user-action-view"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUserClick(user);
                          }}
                          title="View Details"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        </button>

                        <button
                          className={`user-action-btn ${user.status === "Active" ? "user-action-deactivate" : "user-action-activate"}`}
                          onClick={(e) => handleToggleStatus(e, user.id)}
                          title={
                            user.status === "Active" ? "Deactivate" : "Activate"
                          }
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {filteredUsers.length === 0 && (
              <div className="user-empty-state">
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <h3>No users found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {viewMode === "grid" && (
          <div className="user-grid">
            {filteredUsers.map((user) => (
              <div
                key={user.id}
                className="user-card"
                onClick={() => handleUserClick(user)}
              >
                <div className="user-card-header">
                  <div className="user-card-avatar">{user.avatar}</div>
                  <span
                    className={`user-status-indicator user-status-indicator-${user.status.toLowerCase()}`}
                  ></span>
                </div>

                <h3 className="user-card-name">{user.name}</h3>
                <p className="user-card-email">{user.email}</p>

                <div className="user-card-badges">
                  <span
                    className="user-role-badge"
                    style={{
                      backgroundColor: getRoleBadgeColor(user.role).bg,
                      color: getRoleBadgeColor(user.role).color,
                    }}
                  >
                    {user.role}
                  </span>
                  <span
                    className={`user-status-badge user-status-${user.status.toLowerCase()}`}
                  >
                    {user.status}
                  </span>
                </div>

                {user.role === "Mentor" && (
                  <div className="user-card-eligibility">
                    {user.eligibility === "Pending" ? (
                      <div className="user-eligibility-actions">
                        <button
                          className="user-approve-btn"
                          onClick={(e) => handleApprove(e, user.id)}
                        >
                          Approve
                        </button>
                        <button
                          className="user-reject-btn"
                          onClick={(e) => handleReject(e, user.id)}
                        >
                          Reject
                        </button>
                      </div>
                    ) : (
                      <span
                        className="user-eligibility-badge"
                        style={{
                          backgroundColor: getEligibilityBadgeColor(
                            user.eligibility,
                          ).bg,
                          color: getEligibilityBadgeColor(user.eligibility)
                            .color,
                        }}
                      >
                        {user.eligibility}
                      </span>
                    )}
                  </div>
                )}

                <div className="user-card-stats">
                  {user.role === "Student" && (
                    <>
                      <div className="user-card-stat">
                        <span className="user-stat-label">Enrolled</span>
                        <span className="user-stat-value">
                          {user.coursesEnrolled}
                        </span>
                      </div>
                      <div className="user-card-stat">
                        <span className="user-stat-label">Completed</span>
                        <span className="user-stat-value">
                          {user.coursesCompleted}
                        </span>
                      </div>
                    </>
                  )}
                  {user.role === "Mentor" && (
                    <>
                      <div className="user-card-stat">
                        <span className="user-stat-label">Students</span>
                        <span className="user-stat-value">
                          {user.studentsTeaching}
                        </span>
                      </div>
                      <div className="user-card-stat">
                        <span className="user-stat-label">Rating</span>
                        <span className="user-stat-value">
                          ⭐ {user.rating}
                        </span>
                      </div>
                    </>
                  )}
                </div>

                <div className="user-card-footer">
                  <span className="user-joined-text">
                    Joined {user.joinedDate}
                  </span>
                </div>
              </div>
            ))}

            {filteredUsers.length === 0 && (
              <div className="user-empty-state">
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <h3>No users found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {selectedUser && (
          <div className="user-modal-overlay" onClick={closeModal}>
            <div
              className="user-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="user-modal-header">
                <div className="user-modal-user-header">
                  <div className="user-modal-avatar">{selectedUser.avatar}</div>
                  <div>
                    <h3>{selectedUser.name}</h3>
                    <p>{selectedUser.email}</p>
                  </div>
                </div>
                <button className="user-close-btn" onClick={closeModal}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              <div className="user-modal-body">
                <div className="user-badges-section">
                  <span
                    className="user-role-badge"
                    style={{
                      backgroundColor: getRoleBadgeColor(selectedUser.role).bg,
                      color: getRoleBadgeColor(selectedUser.role).color,
                    }}
                  >
                    {selectedUser.role}
                  </span>
                  <span
                    className={`user-status-badge user-status-${selectedUser.status.toLowerCase()}`}
                  >
                    {selectedUser.status}
                  </span>
                  {selectedUser.role === "Mentor" &&
                    selectedUser.eligibility && (
                      <span
                        className="user-eligibility-badge"
                        style={{
                          backgroundColor: getEligibilityBadgeColor(
                            selectedUser.eligibility,
                          ).bg,
                          color: getEligibilityBadgeColor(
                            selectedUser.eligibility,
                          ).color,
                        }}
                      >
                        {selectedUser.eligibility}
                      </span>
                    )}
                </div>

                <div className="user-details-grid">
                  <div className="user-detail-item">
                    <span className="user-detail-label">Email</span>
                    <span className="user-detail-value">
                      {selectedUser.email}
                    </span>
                  </div>
                  <div className="user-detail-item">
                    <span className="user-detail-label">Phone</span>
                    <span className="user-detail-value">
                      {selectedUser.phone}
                    </span>
                  </div>
                  <div className="user-detail-item">
                    <span className="user-detail-label">Location</span>
                    <span className="user-detail-value">
                      {selectedUser.location}
                    </span>
                  </div>
                  <div className="user-detail-item">
                    <span className="user-detail-label">Joined Date</span>
                    <span className="user-detail-value">
                      {selectedUser.joinedDate}
                    </span>
                  </div>
                  {selectedUser.role === "Student" && (
                    <>
                      <div className="user-detail-item">
                        <span className="user-detail-label">
                          Courses Enrolled
                        </span>
                        <span className="user-detail-value">
                          {selectedUser.coursesEnrolled}
                        </span>
                      </div>
                      <div className="user-detail-item">
                        <span className="user-detail-label">
                          Courses Completed
                        </span>
                        <span className="user-detail-value">
                          {selectedUser.coursesCompleted}
                        </span>
                      </div>
                    </>
                  )}
                  {selectedUser.role === "Mentor" && (
                    <>
                      <div className="user-detail-item">
                        <span className="user-detail-label">
                          Students Teaching
                        </span>
                        <span className="user-detail-value">
                          {selectedUser.studentsTeaching}
                        </span>
                      </div>
                      <div className="user-detail-item">
                        <span className="user-detail-label">Rating</span>
                        <span className="user-detail-value">
                          ⭐ {selectedUser.rating}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="user-modal-footer">
                <button className="user-modal-btn user-modal-secondary">
                  Send Message
                </button>
                <button className="user-modal-btn user-modal-secondary">
                  View Activity
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default UsersManagement;
